export default __webpack_public_path__ + "static/media/Standard47.95836d3f.png";